import './assets/tailwind.css';

import { computed, createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import useStore from '@/store';

import App from './App.vue';
import { generateAbsoluteLink } from '@/router';
import { initChat } from '@/ai-chat';

const pinia = createPinia();
//do not remove that line
const app = createApp(App).use(pinia);
const store = useStore();

const headerNav = document.querySelector('.sub-brand-nav > .sub-brand-nav-container > .brand-nav-left');
const mobileMenu = document.querySelectorAll('.sub-brand-nav > .sub-brand-nav-container > .brand-nav-right .ic-menu');
const loginButton = document.querySelectorAll('#brand-cta-button');

if (loginButton) {
  loginButton.forEach((item) => {
    (item as HTMLElement).style.visibility = 'hidden';
  });
}

if (mobileMenu) {
  mobileMenu.forEach((item) => {
    (item as HTMLElement).style.visibility = 'hidden';
  });
}

if (headerNav) {
  const headerNavItems = headerNav.querySelectorAll('.sub-brand-item');
  headerNavItems.forEach((item) => {
    (item as HTMLElement).style.visibility = 'hidden';
  });
}

const searchQuery = new URL(window.location.href).searchParams.get('q');

if (searchQuery !== null) {
  const newUrl = generateAbsoluteLink('search');

  if (newUrl !== window.location.href) {
    window.location.href = newUrl;
  }
}

store.init().then(async () => {
  const router = await import('./router');
  const hasContentLocale = false; //!!store.user.user?.contentLanguage;
  const locale = store.user.user?.contentLanguage.split('-')[0] || 'en';
  localStorage.setItem('locale', store.user.user?.contentLanguage || 'en-US');
  const i18n = createI18n({
    locale: locale,
    messages: { [locale]: hasContentLocale ? store.user.messages : await import('./i18n/en.json') }
  });

  const headerEntry = document.getElementById('header-app-entry');
  // const localeSwitcherEntry = document.getElementById('locale-switcher-app-entry');

  const slideCarouselEntry = document.getElementById('slide-carousel-app-entry');
  const contentEntries = document.querySelectorAll('[id^="content-filter_"][id$="-app-entry"]');
  const footerEntry = document.getElementById('footer-app-entry');
  const userInfoEntry = document.getElementById('user-info-app-entry');

  const catalogEntries = document.querySelectorAll('[id^="catalog-filter_"][id$="-app-entry"]');

  const leaderboardStatsEntry = document.getElementById('leaderboard-stats-app-entry');
  const leaderboardCompletedCoursesEntry = document.getElementById('leaderboard-completed-courses-app-entry');
  const leaderboardRankListEntry = document.getElementById('leaderboard-rank-list-app-entry');

  const livestreamsEntry = document.getElementById('livestreams-app-entry');
  const livestreamPlayerEntry = document.getElementById('livestream-player-app-entry');
  const livestreamsCarouselEntry = document.getElementById('livestreams-carousel-app-entry');

  const promotionsEntry = document.getElementById('promotions-app-entry');
  const promotionsCarouselEntry = document.getElementById('promotions-carousel-app-entry');

  const resourcesEntry = document.getElementById('resources-app-entry');

  const messagesEntry = document.getElementById('messages-app-entry');

  const learningProgramEntry = document.getElementById('learning-program-app-entry');
  const learningProgramContentEntry = document.getElementById('learning-program-content-app-entry');

  const searchEntry = document.getElementById('search-app-entry');
  const searchHeaderEntry = document.getElementById('search-header-app-entry');
  const searchFiltersEntry = document.getElementById('search-filters-app-entry');

  const authEntry = document.getElementById('auth-app-entry');

  // if (localeSwitcherEntry) {
  //   const LocaleSwitcher = await import('@/apps/LocaleSwitcherApp.vue');
  //   const localeSwitcherApp = createApp(LocaleSwitcher.default).use(pinia).use(router.default).use(i18n);
  //   localeSwitcherApp.mount('#locale-switcher');
  // }
  if (slideCarouselEntry) {
    const slideCarousel = await import('@/apps/SlideCarouselApp.vue');
    const slideCarouselApp = createApp(slideCarousel.default).use(pinia).use(router.default).use(i18n);
    slideCarouselApp.mount('#slide-carousel-app-entry');
  }
  if (contentEntries.length > 0) {
    for (const element of contentEntries) {
      const match = element.id.match(/^content-filter_(.+)-app-entry$/);
      const state = match ? match[1] : null;

      if (state) {
        const Content = await import(`@/apps/ContentApp.vue`);
        const contentApp = createApp(Content.default, { state }).use(pinia).use(router.default).use(i18n);
        contentApp.mount(element);
      }
    }
  }
  if (footerEntry) {
    const Footer = await import('@/apps/FooterApp.vue');
    const footerApp = createApp(Footer.default).use(pinia).use(router.default).use(i18n);
    footerApp.mount('#footer-app-entry');
  }
  if (headerEntry) {
    const Header = await import('@/apps/HeaderApp.vue');
    const headerApp = createApp(Header.default).use(pinia).use(router.default).use(i18n);
    headerApp.mount('#header-app-entry');
  }
  if (userInfoEntry) {
    const UserInfo = await import('@/apps/UserInfoApp.vue');
    const userInfoApp = createApp(UserInfo.default).use(pinia).use(router.default).use(i18n);
    userInfoApp.mount('#user-info-app-entry');
  }
  if (leaderboardStatsEntry) {
    const LeaderboardStats = await import('@/apps/LeaderboardStatsApp.vue');
    const leaderboardStatsApp = createApp(LeaderboardStats.default).use(pinia).use(router.default).use(i18n);
    leaderboardStatsApp.mount('#leaderboard-stats-app-entry');
  }
  if (leaderboardCompletedCoursesEntry) {
    const LeaderboardCompletedCourses = await import('@/apps/LeaderboardCompletedCoursesApp.vue');
    const leaderboardCompletedCoursesApp = createApp(LeaderboardCompletedCourses.default)
      .use(pinia)
      .use(router.default)
      .use(i18n);
    leaderboardCompletedCoursesApp.mount('#leaderboard-completed-courses-app-entry');
  }
  if (leaderboardRankListEntry) {
    const LeaderboardRankList = await import('@/apps/LeaderboardRankListApp.vue');
    const leaderboardRankListApp = createApp(LeaderboardRankList.default).use(pinia).use(router.default).use(i18n);
    leaderboardRankListApp.mount('#leaderboard-rank-list-app-entry');
  }
  if (catalogEntries.length > 0) {
    for (const element of catalogEntries) {
      const match = element.id.match(/^catalog-filter_(.+)-app-entry$/);
      const tag = match ? match[1] : null;

      if (tag) {
        const Catalog = await import(`@/apps/CatalogApp.vue`);
        const catalogApp = createApp(Catalog.default, { tag }).use(pinia).use(router.default).use(i18n);
        catalogApp.mount(element);
      }
    }
  }
  if (livestreamsEntry) {
    const Livestreams = await import('@/apps/LivestreamsApp.vue');
    const livestreamsApp = createApp(Livestreams.default).use(pinia).use(router.default).use(i18n);
    livestreamsApp.mount('#livestreams-app-entry');
  }
  if (livestreamPlayerEntry) {
    const LivestreamPlayer = await import('@/apps/LivestreamPlayerApp.vue');
    const livestreamPlayerApp = createApp(LivestreamPlayer.default).use(pinia).use(router.default).use(i18n);
    livestreamPlayerApp.mount('#livestream-player-app-entry');
  }
  if (livestreamsCarouselEntry) {
    const LivestreamsCarousel = await import('@/apps/LivestreamsCarouselApp.vue');
    const livestreamsCarouselApp = createApp(LivestreamsCarousel.default).use(pinia).use(router.default).use(i18n);
    livestreamsCarouselApp.mount('#livestreams-carousel-app-entry');
  }
  if (promotionsEntry) {
    const Promotions = await import('@/apps/PromotionsApp.vue');
    const promotionsApp = createApp(Promotions.default).use(pinia).use(router.default).use(i18n);
    promotionsApp.mount('#promotions-app-entry');
  }
  if (promotionsCarouselEntry) {
    const PromotionsCarousel = await import('@/apps/PromotionsCarouselApp.vue');
    const promotionsCarouselApp = createApp(PromotionsCarousel.default).use(pinia).use(router.default).use(i18n);
    promotionsCarouselApp.mount('#promotions-carousel-app-entry');
  }
  if (resourcesEntry) {
    const Resources = await import('@/apps/ResourcesApp.vue');
    const resourcesApp = createApp(Resources.default).use(pinia).use(router.default).use(i18n);
    resourcesApp.mount('#resources-app-entry');
  }
  if (messagesEntry) {
    const Messages = await import('@/apps/MessagesApp.vue');
    const messagesApp = createApp(Messages.default).use(pinia).use(router.default).use(i18n);
    messagesApp.mount('#messages-app-entry');
  }
  if (searchEntry) {
    const Search = await import('@/apps/SearchApp.vue');
    const searchApp = createApp(Search.default).use(pinia).use(router.default).use(i18n);
    searchApp.mount('#search-app-entry');
  }
  if (searchHeaderEntry) {
    const SearchHeader = await import('@/apps/SearchHeaderApp.vue');
    const searchHeaderApp = createApp(SearchHeader.default).use(pinia).use(router.default).use(i18n);
    searchHeaderApp.mount('#search-header-app-entry');
  }
  if (searchFiltersEntry) {
    const SearchFilters = await import('@/apps/SearchFiltersApp.vue');
    const searchFiltersApp = createApp(SearchFilters.default).use(pinia).use(router.default).use(i18n);
    searchFiltersApp.mount('#search-filters-app-entry');
  }
  if (learningProgramEntry) {
    const LearningProgram = await import('@/apps/LearningProgramApp.vue');
    const learningProgramApp = createApp(LearningProgram.default).use(pinia).use(router.default).use(i18n);
    learningProgramApp.mount('#learning-program-app-entry');
  }
  if (learningProgramContentEntry) {
    const LearningProgramContent = await import('@/apps/LearningProgramContentApp.vue');
    const learningProgramContentApp = createApp(LearningProgramContent.default)
      .use(pinia)
      .use(router.default)
      .use(i18n);
    learningProgramContentApp.mount('#learning-program-content-app-entry');
  }
  if (authEntry) {
    const Auth = await import('@/apps/AuthApp.vue');
    const authApp = createApp(Auth.default).use(pinia).use(router.default).use(i18n);
    authApp.mount('#auth-app-entry');
  }

  const isAuthenticated = computed(() => store.isAuthenticated);
  const isLoginPage = window.location.href.includes('/login');

  if (loginButton && !isAuthenticated.value && isLoginPage) {
    loginButton.forEach((item) => {
      (item as HTMLElement).style.visibility = 'visible';
    });
  }

  if (isLoginPage && isAuthenticated.value) {
    window.location.href = generateAbsoluteLink('home');
    return;
  }

  // if (loginButton && isAuthenticated.value) {
  //   loginButton.forEach((item) => {
  //     const span = item.querySelector('span');
  //     if (span) {
  //       span.textContent = 'Log Out';
  //     }
  //   });
  // }

  setTimeout(() => {
    window.dispatchEvent(new Event('resize')); // reposition login button
  }, 0);

  if (mobileMenu && isAuthenticated.value) {
    mobileMenu.forEach((item) => {
      (item as HTMLElement).style.visibility = 'visible';
    });
  }

  if (headerNav && isAuthenticated.value) {
    const headerNavItems = headerNav.querySelectorAll('.sub-brand-item');

    headerNavItems.forEach((item) => {
      (item as HTMLElement).style.visibility = 'visible';
    });
  }

  // if (
  //   headerNav &&
  //   isAuthenticated.value &&
  //   store.config.config.NV_NORTHAM_GROUP_ID &&
  //   !store.user.userGroups.some((group) => {
  //     return store.config.config.NV_NORTHAM_GROUP_ID === group.id;
  //   })
  // ) {
  //   (headerNav.querySelector('.sub-brand-item:nth-child(5)') as HTMLElement).style.display = 'none';
  // }

  if (
    headerNav &&
    isAuthenticated.value &&
    store.config.config.NV_ALLOWED_USER_GROUPS &&
    !store.user.userGroups.some((group) => {
      return store.config.config.NV_ALLOWED_USER_GROUPS.split(',').includes(group.id);
    })
  ) {
    (headerNav.querySelector('.sub-brand-item:nth-child(6)') as HTMLElement).style.display = 'none';
  }

  const parent = document.getElementsByClassName('nv-account-dropdown-loggedinuser')[0];

  if (store.user.user?.roles.includes('Admin') && parent && parent.children.length > 0) {
    const tempTemplate = document.createElement('div');
    tempTemplate.innerHTML = `
        <div class="nv-account-dropdown-item">
            <a href="https://learningmanager.adobe.com/app/admin?accountId=40597" target="_blank">
                <div class="nv-account-dropdown-icon-container">
                    <i class="fa-sharp fa-regular fa-briefcase"></i>
                </div>
                <span>ALM Admin Access</span>
            </a>
        </div>`.trim();

    const newNode = tempTemplate.firstChild;

    if (newNode) {
      parent.insertBefore(newNode, parent.lastElementChild);
    }
  }

  const hasAccessToChat = store.user.userGroups.some((group) => {
    return true;
    // return store.config.config.NV_AI_CHAT_USER_GROUPS.split(',').includes(group.id);
  });

  if (hasAccessToChat && store.authService.auth?.access_token) {
    void initChat(store.authService.auth?.access_token);
  }
});
